import { PageLayout, ProjectDetails, SEO } from "../components";

const ProjectDetailsPage = () => {
  return (
    <PageLayout>
      <SEO
        url="/project-details/:id"
        openGraphType="website"
        schemaType="website"
        title="Project details page"
        description="We help you transition into tech seamlessly."
      />

      <div className="w-full pt-[118px]">
        <ProjectDetails />
      </div>
    </PageLayout>
  );
};

export default ProjectDetailsPage;
